export function getAppMode(): string {
  return import.meta.env.MODE;
}

export function getSquareConfig() {
  return {
    appId: import.meta.env.VITE_SQUARE_APP_ID ?? "",
    locationId: import.meta.env.VITE_SQUARE_LOCATION_ID ?? "",
    sdkUrl: (import.meta.env.VITE_SQUARE_SDK_URL as string | undefined)
      ?? "https://sandbox.web.squarecdn.com/v1/square.js",
    apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined)
      ?? "https://api.ratefollowup.com",
  };
}

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export function getFirebaseEnv() {
  return {
    firebaseConfig,
    isConfigured: Object.values(firebaseConfig).every(Boolean),
  };
}
